
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakiety",
      function () {
        return require("private-next-pages/pakiety/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakiety"])
      });
    }
  